import React from 'react';
import { AlertTriangleIcon } from 'lucide-react';
export function ProblemSection() {
  return <section className="py-16 md:py-24 bg-[#0f172a]" data-id="element-119">
      <div className="max-w-4xl mx-auto px-4 sm:px-6" data-id="element-120">
        <div className="text-center mb-12" data-id="element-121">
          <div className="inline-flex items-center justify-center p-3 bg-red-500/10 rounded-full mb-4" data-id="element-122">
            <AlertTriangleIcon className="w-8 h-8 text-red-400" data-id="element-123" />
          </div>
          <h2 className="text-3xl md:text-4xl font-bold text-white" data-id="element-124">
            El Verdadero Problema
          </h2>
        </div>

        <div className="grid md:grid-cols-2 gap-8 md:gap-12" data-id="element-125">
          <div className="bg-slate-800/40 p-8 rounded-2xl border border-slate-700/50" data-id="element-126">
            <h3 className="text-xl font-bold text-teal-400 mb-4" data-id="element-127">
              El Cerebro con ADHD
            </h3>
            <p className="text-slate-300 leading-relaxed" data-id="element-128">
              Para el cerebro con ADHD, si algo no está en su campo de visión
              inmediato, deja de existir. No es que ignores a tu pareja a
              propósito; es que tu cerebro "borra" las tareas aburridas para
              sobrevivir al ruido mental constante.
            </p>
          </div>

          <div className="bg-slate-800/40 p-8 rounded-2xl border border-slate-700/50" data-id="element-129">
            <h3 className="text-xl font-bold text-amber-400 mb-4" data-id="element-130">
              La Pareja Agotada
            </h3>
            <p className="text-slate-300 leading-relaxed" data-id="element-131">
              Tu pareja, por otro lado, está agotada de llevar toda la "carga
              mental". Siente que es la única persona adulta en la relación y
              ese desequilibrio está matando la intimidad.
            </p>
          </div>
        </div>

        <div className="mt-8 text-center bg-slate-800/60 p-6 rounded-xl border border-slate-700" data-id="element-132">
          <p className="text-lg md:text-xl text-slate-200 font-medium" data-id="element-133">
            Las notas adhesivas se pierden, las alarmas se ignoran y las
            promesas de "mañana lo haré" han perdido toda su credibilidad.
          </p>
        </div>
      </div>
    </section>;
}